<template>
  <li style="cursor: pointer" class="list-group-item">
    <div class="activity-container">
      <span class="activities-date">
        {{
          activity.created_at
            | formatDate({
              format: getUserProfile.format_date,
              timezone: getUserProfile.timezone,
              hasHourAndMinutes: true,
            })
        }}
      </span>
      <div
        @click="handleClickActivity"
        class="activity-wrapper d-flex"
        :style="activity['job-id'] ? {} : { 'align-items': 'center' }"
      >
        <popper
          :append-to-body="true"
          trigger="hover"
          :options="{
            placement: 'top',
            modifiers: { offset: { offset: '10,20px' } },
          }"
        >
          <div class="popper">{{ activity.creator_name ? activity.creator_name : 'Jobshark' }}</div>

          <div slot="reference">
            <figure>
              <img
                v-if="
                  activity.creator_photo !== null &&
                    activity.creator_photo !== 'null' &&
                    activity.creator_photo !== 'default.png'
                "
                :src="`https://jobshark.eu/storage/avatars/${activity.creator_photo}`"
                style="object-fit: cover"
                alt="avatar-1"
                class="avatar"
              />
              <img
                v-else
                src="https://jobshark.eu/img/comstream.svg"
                style="object-fit: contain"
                alt="avatar-1"
                class="avatar"
              />
            </figure>
          </div>
        </popper>

        <div style="width:100%">
          <div class="activities-body" v-if="activity.type === 'General'">
            <span class="title" v-if="!activity.candidate_name"
              ><router-link :to="{ name: 'job_uuid', params: { job_uuid: activity['job-id'] } }"
                >{{ activity.job }}
                {{
                  activity['job-address'] && activity['job-address'].city_name
                    ? `, ${activity['job-address'].city_name}`
                    : ''
                }}
              </router-link></span
            >

            <span class="title" v-if="activity.candidate_name"
              ><router-link
                :to="{ name: 'candidate_id', params: { candidate_id: activity.candidate_id } }"
                >{{ activity.candidate_name }}</router-link
              >
            </span>
            <span class="employer-name-actv"
              ><router-link
                :to="{
                  name: 'employer_id',
                  params: { employer_id: activity['employer-id'] },
                }"
                >{{ activity.employer }}</router-link
              ></span
            >
            <p>
              {{ activity.comments }}
            </p>
          </div>

          <div class="activities-body" v-else-if="activity.type === 'Qualification'">
            <span class="title" v-if="!activity.candidate_name"
              ><router-link :to="{ name: 'job_uuid', params: { job_uuid: activity['job-id'] } }"
                >{{ activity.job
                }}{{
                  activity['job-address'] && activity['job-address'].city_name
                    ? `, ${activity['job-address'].city_name}`
                    : ''
                }}
              </router-link></span
            >

            <span class="title" v-if="activity.candidate_name"
              ><!-- <router-link
                  :to="{ nname: 'candidate_id', params: { candidate_id: candidate.id } }"
                  >{{ activity.candidate_name }}</router-link> -->
              <router-link
                :to="{ name: 'candidate_id', params: { candidate_id: activity.candidate_id } }"
                >{{ activity.candidate_name }}</router-link
              ></span
            >
            <span class="employer-name-actv" v-if="!removeEmployerName"
              ><router-link
                :to="{
                  name: 'employer_id',
                  params: { employer_id: activity['employer-id'] },
                }"
                >{{ activity.employer }}</router-link
              ></span
            >
            <p>
              <span>Qualification change:</span>
              <span class="modal-text-color">
                {{ getQualificationMixin(activity.qualification).title }}
              </span>
              <span>{{ activity.comments ? `- ${activity.comments}` : '' }}</span>
            </p>
          </div>

          <div class="activities-body" v-else-if="activity.type === 'Stage'">
            <span class="title" v-if="!activity.candidate_name"
              ><router-link :to="{ name: 'job_uuid', params: { job_uuid: activity['job-id'] } }"
                >{{ activity.job
                }}{{
                  activity['job-address'] && activity['job-address'].city_name
                    ? `, ${activity['job-address'].city_name}`
                    : ''
                }}</router-link
              ></span
            >

            <!-- TODO: add candidate id to router link -->
            <span class="title" v-if="activity.candidate_name"
              ><!-- <router-link
                  :to="{ nname: 'candidate_id', params: { candidate_id: candidate.id } }"
                  >{{ activity.candidate_name }}</router-link> -->
              <router-link
                :to="{ name: 'candidate_id', params: { candidate_id: activity.candidate_id } }"
                >{{ activity.candidate_name }}</router-link
              ></span
            >
            <span class="employer-name-actv" v-if="!removeEmployerName"
              ><router-link
                :to="{
                  name: 'employer_id',
                  params: { employer_id: activity['employer-id'] },
                }"
                >{{ activity.employer }}</router-link
              ></span
            >
            <p>
              <span>Stage change:</span>
              <span class="modal-text-color">
                {{ getStageMixin(activity.stage).title }}
              </span>
              <span>{{ activity.comments ? `- ${activity.comments}` : '' }}</span>
            </p>
          </div>

          <div class="activities-body" v-else-if="activity.type === 'Account_created'">
            <!-- <p>
                 <span v-show="activity.qualification">Qualification change:</span>
                <span class="modal-text-color">
                  {{ getQualificationMixin(activity.qualification).title }}</span
                >
                <span>{{ activity.comments ? `- ${activity.comments}` : '' }}</span>
              </p> -->

            <p>
              {{ 'Account created' }}
            </p>
          </div>

          <div class="activities-body" v-else-if="activity.type === 'Pipeline'">
            <p>
              <!--  public const ACTIVITY_PIPELINE_APPLIED = 1;
                  public const ACTIVITY_PIPELINE_ADDED = 2;
                  public const ACTIVITY_PIPELINE_REMOVED = 3; -->

              <span v-if="activity.activity_pipeline == 1">
                <span class="title" v-if="!activity.candidate_name"
                  ><router-link :to="{ name: 'job_uuid', params: { job_uuid: activity['job-id'] } }"
                    >{{ activity.job
                    }}{{
                      activity['job-address'] && activity['job-address'].city_name
                        ? `, ${activity['job-address'].city_name}`
                        : ''
                    }}
                  </router-link></span
                >
                <span class="title" v-if="activity.candidate_name">
                  <router-link
                    :to="{
                      name: 'candidate_id',
                      params: { candidate_id: activity.candidate_id },
                    }"
                    >{{ activity.candidate_name }}</router-link
                  ></span
                >
                <span class="employer-name-actv" v-if="!removeEmployerName"
                  ><router-link
                    :to="{
                      name: 'employer_id',
                      params: { employer_id: activity['employer-id'] },
                    }"
                    >{{ activity.employer }}</router-link
                  ></span
                >
                <p>
                  <span>Applied: </span>
                  <span class="modal-text-color">
                    {{ getQualificationMixin(activity.qualification).title }}
                  </span>
                  <span>{{ activity.comments ? `- ${activity.comments}` : '' }}</span>
                </p>
              </span>

              <span v-if="activity.activity_pipeline == 2">
                <span class="title" v-if="!activity.candidate_name"
                  ><router-link :to="{ name: 'job_uuid', params: { job_uuid: activity['job-id'] } }"
                    >{{ activity.job
                    }}{{
                      activity['job-address'] && activity['job-address'].city_name
                        ? `, ${activity['job-address'].city_name}`
                        : ''
                    }}
                  </router-link></span
                >

                <span class="title" v-if="activity.candidate_name">
                  <router-link
                    :to="{
                      name: 'candidate_id',
                      params: { candidate_id: activity.candidate_id },
                    }"
                    >{{ activity.candidate_name }}</router-link
                  ></span
                >
                <span class="employer-name-actv" v-if="!removeEmployerName"
                  ><router-link
                    :to="{
                      name: 'employer_id',
                      params: { employer_id: activity['employer-id'] },
                    }"
                    >{{ activity.employer }}</router-link
                  ></span
                >
                <p>
                  <span>Added to pipeline: </span>
                  <span class="modal-text-color">
                    {{ getQualificationMixin(activity.qualification).title }}
                  </span>
                  <span>{{ activity.comments ? `- ${activity.comments}` : '' }}</span>
                </p>
              </span>

              <span v-if="activity.activity_pipeline == 3">
                <span class="title">
                  <router-link :to="{ name: 'job_uuid', params: { job_uuid: activity['job-id'] } }"
                    >{{ activity.job }},
                    {{
                      activity['job-address'] ? activity['job-address'].city_name : ''
                    }}</router-link
                  ></span
                >
                <span class="employer-name-actv" v-if="!removeEmployerName"
                  ><router-link
                    :to="{
                      name: 'employer_id',
                      params: { employer_id: activity['employer-id'] },
                    }"
                    >{{ activity.employer }}</router-link
                  ></span
                >
                <p>
                  <span>Removed from pipeline: </span>
                  <span class="modal-text-color">
                    {{ getQualificationMixin(activity.qualification).title }}
                  </span>
                  <span>{{ activity.comments ? `- ${activity.comments}` : '' }}</span>
                </p>
              </span>
              <span v-if="activity.activity_pipeline == null">
                <p>
                  <span style="font-weight:400!important; padding-right:95px!important">{{
                    activity.comments ? `${activity.comments}` : ''
                  }}</span>
                </p>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Show Activity Modal -->
    <CustomMainModal @close="onCloseActivityModal" v-show="showModal">
      <template v-slot:header>
        <h5>Activity</h5>
      </template>
      <div class="modal-body">
        <ul class="list-unstyled modal-activity">
          <li>
            <span class="title">Candidate:</span>
            {{
              activity.hasOwnProperty('candidate_name')
                ? activity.candidate_name
                : `${getCandidateById.first_name} ${getCandidateById.last_name}`
            }}
          </li>
          <li class="d-flex">
            <span class="title">Job:</span>

            <span v-show="activity.job"> {{ activity.job }}, {{ getCityName() }} </span>
          </li>
          <li><span class="title">Employer:</span>{{ activity.employer }}</li>
          <li class="d-flex">
            <span class="title">Activity:</span>

            <span v-if="activity.type === 'General'">{{ activity.type }}</span>

            <span v-if="activity.type === 'Stage'">
              Stage change:
              <span class="modal-text-color">{{ getStageMixin(activity.stage).title }}</span>
            </span>

            <span v-if="activity.type === 'Qualification'">
              Qualification change:
              <span class="modal-text-color">
                {{ getQualificationMixin(activity.qualification).title }}
              </span>
            </span>

            <span v-if="activity.type === 'Account_created'">
              Added by {{ activity.creator_name }}
            </span>

            <span v-if="activity.type === 'Pipeline'">
              <!-- 
                  public const ACTIVITY_PIPELINE_APPLIED = 1;
                  public const ACTIVITY_PIPELINE_ADDED = 2;
                  public const ACTIVITY_PIPELINE_REMOVED = 3;
               -->

              <span v-if="activity.activity_pipeline == 1">
                Applied by {{ activity.creator_name }}
              </span>

              <span v-if="activity.activity_pipeline == 2">
                Added to pipeline by {{ activity.creator_name }}
              </span>

              <span v-if="activity.activity_pipeline == 3">
                Removed from pipeline by {{ activity.creator_name }}
              </span>
              <span v-if="activity.activity_pipeline == null">
                {{ activity.comments }}
              </span>
            </span>
          </li>

          <li>
            <span class="title"></span>
            <textarea
              v-model="activityComment"
              class="form-control"
              rows="2"
              placeholder="Comment"
            ></textarea>
          </li>

          <li>
            <span class="title">Date:</span
            >{{
              activity.created_at
                | formatDate({
                  format: getUserProfile.format_date,
                  timezone: getUserProfile.timezone,
                  hasHourAndMinutes: true,
                })
            }}
          </li>
        </ul>

        <div class="modal-footer d-flex justify-content-center">
          <button @click="onUpdateActivity" type="button" class="btn btn-primary">
            Save and close
          </button>
          <button
            type="button"
            class="btn btn-secondary mr-3"
            data-dismiss="modal"
            @click="onCloseActivityModal"
          >
            Cancel
          </button>
          <i
            v-if="activity.type === 'General'"
            style="cursor: pointer; font-size: 20px"
            data-bs-toggle="modal"
            :data-bs-target="`#deleteActivityModal-${activity.activity_id}`"
            class="fas fa-trash-alt"
            ref="closeShowActivityModalBtn"
          ></i>
        </div>
      </div>
    </CustomMainModal>
    <!-- End Show Activity Modal -->

    <!-- Delete Activity -->
    <div
      style="z-index: 100000000"
      class="modal fade"
      :id="`deleteActivityModal-${activity.activity_id}`"
      tabindex="-1"
      aria-labelledby="deleteActivityModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModal2Label">Delete Activity</h5>
            <button
              ref="closeModalBtn"
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-center justify-content-center">
            <p>Please confirm that you want to delete this activity.</p>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="onRemoveActivity" type="button" class="btn btn-primary">Delete</button>

            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Delete Activity -->
  </li>
</template>

<script>
import CustomMainModal from '../../Modals/CustomMainModal';
// import ErrorList from '@/components/common/errorsList';

import { stagesMixin } from '../../../mixins/stagesMixin';
import { qualificationMixin } from '../../../mixins/qualificationMixin';
import { mapActions, mapGetters } from 'vuex';
import AvatarPreviewOnly from '../../common/AvatarPreviewOnly.vue';

export default {
  components: { CustomMainModal /* ErrorList */, AvatarPreviewOnly },
  mixins: [stagesMixin, qualificationMixin],
  props: {
    activity: {
      type: Object,
      default: () => {},
    },
    removeEmployerName: {
      type: Boolean,
    },
  },
  data: () => ({
    activityComment: '',
    showModal: false,
  }),
  methods: {
    ...mapActions(['removeActivity', 'updateActivity']),
    onUpdateActivity() {
      this.updateActivity({
        activity_id: this.activity.activity_id,
        activity_comment: this.activityComment,
      }).then(() => {
        this.showModal = false;
        this.$emit('removed-activity');
      });
    },
    onRemoveActivity() {
      this.removeActivity({ activityID: this.activity.activity_id }).then(() => {
        this.$refs.closeModalBtn.click();

        // this.closeShowActivityModalBtn.click();

        this.$emit('removed-activity');
        this.showModal = false;
      });
    },
    getCityName() {
      if (this.activity['job-address']) {
        if (this.activity['job-address'].hasOwnProperty('city_name')) {
          return this.activity['job-address'].city_name;
        }
      }

      return 'N/A';
    },
    handleClickActivity() {
      /* console.log('handleClickActivity: ', this.activity); */
      this.showModal = true;

      this.activityComment = this.activity.comments;
    },
    onCloseActivityModal() {
      this.showModal = false;
    },
    setActivityForDelete(activity) {
      this.activityForDelete = activity;
    },
  },
  computed: {
    ...mapGetters(['getCandidateById', 'getUserProfile']),
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

figure {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  margin: 0 15px 0 10px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 0;
    object-fit: cover;
  }
}

p {
  margin: 0;
  padding: 0;
}
.activities-body {
  width: 100%;
}

.activities-date {
  position: absolute;
  display: block;
  white-space: nowrap;
  right: 15px;
  color: #000;
  font-size: 13px;
}

.activity-message {
  height: 36px !important;
  padding-top: 0 !important;
}

.modal-activity {
  font-size: 14px;
  li {
    margin-bottom: 12px;
    border: none !important;
    background: none !important;
    padding-right: 0 !important;
    span.title {
      font-weight: 700;
      min-width: 120px;
      display: inline-block;
    }
    .stat {
      background: #465c74;
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 50%;
      margin-left: 15px;
    }
  }
}

.activities-body {
  .title {
    display: block;
    width: 100%;
    padding-right: 90px;
  }
  .employer-name-actv {
    color: #666;
  }
  p {
    span {
      font-weight: 600;
    }
  }
}

.list-group-item {
  position: relative;
  padding-left: 0 !important;
}
</style>
